import LoginForm from '../components/forms/LoginForm'

function LoginView({ props }) {

    return <div id="login-view-container">
        <LoginForm></LoginForm>
        <div id="floating-decoration-bottom-left"></div>
        <div id="floating-decoration-top-right"></div>
        <div id="floating-decoration-bottom-right" className="align-items-center">
            <i id="float-decoration-bottom-right-dot" className="mdi mdi-circle-medium text-32 fg-orange"></i>
            <i className="mdi mdi-office-building text-44 fg-orange"></i>
        </div>
        <div id="floating-version-text">v202501081239</div>
    </div>;
}

export default LoginView